let appTableView = () =>
    import(
        /* webpackChunkName: "schemaTableView" */ "@/features/schemas/views/SchemaTableView.vue");

export default [
    {
        path: "/action-logs",
        name: "actionLogs",
        staticProps: { entityKey: "actionLog" },
    },
    {
        path: "/articles",
        name: "articles",
        staticProps: { entityKey: "article" },
    },
    {
        path: "/article-comments",
        name: "articleComments",
        staticProps: { entityKey: "articleComment" },
    },
    {
        path: "/article-details",
        name: "articleDetails",
        staticProps: { entityKey: "articleDetail" },
    },
    {
        path: "/article-files",
        name: "articleFiles",
        staticProps: { entityKey: "articleFile" },
    },
    {
        path: "/categories",
        name: "categories",
        staticProps: { entityKey: "category" },
    },
    {
        path: "/clients",
        name: "clients",
        staticProps: { entityKey: "client" },
    },
    {
        path: "/contacts",
        name: "contacts",
        staticProps: { entityKey: "contact" },
    },
    {
        path: "/contact-addresses",
        name: "contactAddresses",
        staticProps: { entityKey: "contactAddress" },
    },
    {
        path: "/contact-emails",
        name: "contactEmails",
        staticProps: { entityKey: "contactEmail" },
    },
    {
        path: "/contact-phones",
        name: "contactPhones",
        staticProps: { entityKey: "contactPhone" },
    },
    {
        path: "/departments",
        name: "departments",
        staticProps: { entityKey: "department" },
    },
    {
        path: "/deployments",
        name: "deployments",
        staticProps: { entityKey: "deployment" },
    },
    {
        path: "/deployment-snapshots",
        name: "deploymentSnapshots",
        staticProps: { entityKey: "deploymentSnapshot" },
    },
    {
        path: "/files",
        name: "files",
        staticProps: { entityKey: "file" },
    },
    {
        path: "/job-titles",
        name: "jobTitles",
        staticProps: { entityKey: "jobTitle" },
    },
    {
        path: "/projects",
        name: "projects",
        staticProps: { entityKey: "project" },
    },
    {
        path: "/project-job-titles",
        name: "projectJobTitles",
        staticProps: { entityKey: "projectJobTitle" },
    },
    {
        path: "/project-tasks",
        name: "projectTasks",
        staticProps: { entityKey: "projectTask" },
    },
    {
        path: "/proposals",
        name: "proposals",
        staticProps: { entityKey: "proposal" },
    },
    {
        path: "/proposal-comments",
        name: "proposalComments",
        staticProps: { entityKey: "proposalComment" },
    },
    {
        path: "/proposal-emails",
        name: "proposalEmails",
        staticProps: { entityKey: "proposalEmail" },
    },
    {
        path: "/proposal-email-templates",
        name: "proposalEmailTemplates",
        staticProps: { entityKey: "proposalEmailTemplate" },
    },
    {
        path: "/proposal-items",
        name: "proposalItems",
        staticProps: { entityKey: "proposalItem" },
    },
    {
        path: "/proposal-sections",
        name: "proposalSections",
        staticProps: { entityKey: "proposalSection" },
    },
    {
        path: "/proposal-signings",
        name: "proposalSignings",
        staticProps: { entityKey: "proposalSigning" },
    },
    {
        path: "/proposal-templates",
        name: "proposalTemplates",
        staticProps: { entityKey: "proposalTemplate" },
    },
    {
        path: "/question-options",
        name: "questionOptions",
        staticProps: { entityKey: "questionOption" },
    },
    {
        path: "/question-responses",
        name: "questionResponses",
        staticProps: { entityKey: "questionResponse" },
    },
    {
        path: "/regions",
        name: "regions",
        staticProps: { entityKey: "region" },
    },
    {
        path: "/roles",
        name: "roles",
        staticProps: { entityKey: "role" },
    },
    {
        path: "/role-claims",
        name: "roleClaims",
        staticProps: { entityKey: "roleClaim" },
    },
    {
        path: "/rosters",
        name: "rosters",
        staticProps: { entityKey: "roster" },
    },
    {
        path: "/settings",
        name: "settings",
        staticProps: { entityKey: "setting" },
    },
    {
        path: "/sites",
        name: "sites",
        staticProps: { entityKey: "site" },
    },
    {
        path: "/staff-members",
        name: "staffMembers",
        staticProps: { entityKey: "staffMember" },
    },
    {
        path: "/surveys",
        name: "surveys",
        staticProps: { entityKey: "survey" },
    },
    {
        path: "/survey-questions",
        name: "surveyQuestions",
        staticProps: { entityKey: "surveyQuestion" },
    },
    {
        path: "/survey-responses",
        name: "surveyResponses",
        staticProps: { entityKey: "surveyResponse" },
    },
    {
        path: "/users",
        name: "users",
        staticProps: { entityKey: "user" },
    },
    {
        path: "/user-roles",
        name: "userRoles",
        staticProps: { entityKey: "userRole" },
    },
    {
        path: "/proposal-snapshots",
        name: "proposalSnapshots",
        staticProps: { entityKey: "proposalSnapshot" },
    }
].map(e => {
    return { ...e, component: appTableView };
});
